import { useQuery } from '@tanstack/react-query';
import { threadsApi } from '../api/threads';

export const useThreadDetail = (threadId: string | null) => {
  return useQuery({
    queryKey: ['threadDetail', threadId],
    queryFn: () => threadsApi.getById(threadId!),
    enabled: !!threadId,
  });
};
